import { SDSuperChart, AxisOptions, SDLine, VLine } from '@lightwaverf/simple-d3-graph';
import { LwGeneralGraph } from './general-graph';
import { GlobalVariablesService, time } from '../../services/global-variables.service';
import { timeFormat } from 'd3';
import { DateTime } from 'luxon';

export const targetAxisIndex = ['y', 'y2'];
export const targetLayerIndex = ['outputLayer', 'areaGraphLayer'];

export class LwAverageEnergyGraph extends LwGeneralGraph {

    graph: any;
    constructor(element) {
        super(element);
    }

    draw(data: any[]) {
        this.graph = new SDSuperChart(this.element);
        let mainGraphData = [];
        let currentDay = Date.now() - Date.now() % time.day;
        data[0] = data[0].map((a) => {
            return {
                date: new Date(a.timestamp),
                timestamp: a.timestamp,
                value: a.value
            };
        });
        if (data[1]) {
          data[1] = data[1].map((a) => {
              return {
                  date: new Date(a.timestamp),
                  timestamp: a.timestamp,
                  value: a.value
              };
          });
        }

        mainGraphData[0] = {
            data: data[0],
            options: {},
            appearance:
            {
              color: '#0E8E75',
              shape: 'special-line',
              format: 'iso',
              curveType: 'stepAfter',
              coordinateMoveFunc: false
            }
            // appearance: { shape: 'bar', format: '%H:%M', barWidth: 70, color: '#0E8E75' }
        };
        if (data[1]) {
          mainGraphData[1] = {
            data: data[1],
            options: {},
            appearance:
            {
              color: '#ff0000',
              shape: 'special-line',
              format: 'iso',
              curveType: 'stepAfter',
              coordinateMoveFunc: true
            }
        }
          // appearance: { shape: 'bar', format: '%H:%M', barWidth: 70, color: '#0E8E75' }
      };

        let axisOptions: AxisOptions = {
            ticks: {
                format: '%H:%M'
            },
            scaleType: 'time-utc'

        };

        let graphOptions = {
            chartArea: {
                clipId: 'hh-clip',
                height: 140,
                margin: {
                    top: 20
                }
            },
            axis:
            {
                x: axisOptions,
                y: {
                    title: 'Energy',
                    unit: 'Wh',
                    paddingTop: 0.1,
                    paddingBottom: 0,
                }
            },
            explorer: {
                brush: false,
                coordinates: true
            }
        };
        this.graph.draw(mainGraphData, graphOptions);
        this.addHoverEffects();
    }

    private addHoverEffects() {
      this.graph.coordinates.addOverlayMouseInFunc(() => {
          this.graph.coordinates.show();
          this.graph.tooltip.show();
      });
      this.graph.coordinates.addOverlayMouseOutFunc(() => {
          this.graph.coordinates.hide();
          this.graph.tooltip.hide();
      });
      this.graph.series[0].addCoordinatorMoveFunc((mouseCoord: any) => {
          const dataPoint = (this.graph.series[0] as SDLine).findDataPoint(mouseCoord, true);

          const { x, y, value, x0 } = dataPoint;

          (this.graph.series[0] as SDLine).selectionCircle
              .attr('visibility', 'visible')
              .attr('cx', x)
              .attr('cy', y);

          const { value: value1 } = (this.graph.series[0] as SDLine).findDataPoint([x, y]);
          const dt = DateTime.fromMillis(this.graph.data[0].raw[value].timestamp);
          const displayTime = dt.toLocaleString(DateTime.TIME_24_SIMPLE)
          let tooltip;
          if (this.graph.series[1]) {
            tooltip = `
                <div class="tooltip-text title">${displayTime}</div>
                <div class="tooltip-text item">
                    <span class="dot" style="background-color:${this.graph.series[0].color}"></span>
                    <span class="sd-flex">Energy: ${this.graph.data[0].raw[value].value} Wh</span>
                </div>
                <div class="tooltip-text item">
                    <span class="dot" style="background-color:${this.graph.series[1].color}"></span>
                    <span class="sd-flex">Avg Cost: £${(this.graph.data[1].raw[value1].value / 100).toFixed(2)}</span>
                </div>
            `;
          } else {
            tooltip = `
            <div class="tooltip-text title">${displayTime}</div>
            <div class="tooltip-text item">
                <span class="dot" style="background-color:${this.graph.series[0].color}"></span>
                <span class="sd-flex">Energy: ${this.graph.data[0].raw[value].value} Wh</span>
            </div>
        `;
          }

          let x3 = this.graph.x.func(x0);
          // (this.graph.coordinates as VLine).move(x3);

          const { value: value3 } = (this.graph.series[0] as SDLine).findDataPoint([x3, y]);

          this.graph.tooltip.html(
              `<div class="tooltip-text item">
                  <span class="sd-flex">Valve Level: ${this.graph.data[0].raw[value3].value} %</span>
              </div>`
          );

          this.graph.tooltip.move(x3, 20);


          this.graph.tooltip.html(tooltip)
              .move(x, 30)
              .show();

      });
    }
}
